// api/envelopes.ts
import { responseHero } from "../utils/axiosInterceptor";

// ==== Query options (összhangban a backend controllerrel) ====
export type FormDataMode = "none" | "radio-only" | "full";

// api/envelopes.ts
export interface GetEnvelopeStatusesOptions {
    formDataMode?: FormDataMode;   // default: "radio-only"
    concurrency?: number;          // default: 8
    includeRelations?: boolean;    // default: false
    /** ÚJ: ezeknél a DB státuszoknál nem hívjuk a DocuSignt a backendben */
    skipIfDbStatusIn?: string[];   // pl. ["voided"]
  }
  
  // Válasz típus bővítése
  export interface EnvelopeStatusItem {
    refId: string;
    status: string;
    radioValue?: string;
    envelope?: any | null;
    envelopeFormData?: any;
    error?: string;
    dsStatus?: number;
    dsBody?: string;
    /** ÚJ: backend most ezt is visszaadhatja */
    dsErrorCode?: string;
    formDataError?: string;
  }
  
  export const getEnvelopeStatuses = async (
    refIds: string[],
    options: GetEnvelopeStatusesOptions = {}
  ): Promise<EnvelopeStatusItem[]> => {
    const {
      formDataMode = "radio-only",
      concurrency = 8,
      includeRelations = false,
      skipIfDbStatusIn = [],             // ÚJ: default üres
    } = options;
  
    const url = `${process.env.REACT_APP_API_URL}/envelopes/statuses`;
    const params = { formDataMode, concurrency, includeRelations, skipIfDbStatusIn }; // ÚJ: felküldjük
  
    try {
      const { data } = await responseHero.post<EnvelopeStatusItem[]>(url, { refIds }, { params });
  
      data.filter((item) => item.error).forEach((item) => {
        console.error(`[getEnvelopeStatuses] Error for refId=${item.refId}`, {
          status: item.status,
          error: item.error,
          dsStatus: item.dsStatus,
          dsErrorCode: item.dsErrorCode,   // ÚJ: logoljuk
          dsBody: item.dsBody,
          formDataError: item.formDataError,
        });
      });
  
      return data;
    } catch (err: any) {
      console.error("[getEnvelopeStatuses] Fatal request error", {
        message: err?.message,
        stack: err?.stack,
        response: err?.response?.data,
        status: err?.response?.status,
      });
      throw err;
    }
  };
  
  

/**
 * Egy elem lekérő helper, a batch végpontot használja.
 * Alapértelmezések megegyeznek a "legacy" teljes részletezésű viselkedéssel.
 */
export const getEnvelopeStatus = async (
  refId: string,
  options?: GetEnvelopeStatusesOptions
): Promise<EnvelopeStatusItem> => {
  const [item] = await getEnvelopeStatuses([refId], {
    formDataMode: "full",
    includeRelations: true,
    concurrency: 1,
    ...options,
  });
  return item;
};
